import { render } from "./DropHistoryOrders.vue?vue&type=template&id=98b9ec8a&scoped=true"
import script from "./DropHistoryOrders.vue?vue&type=script&lang=js"
export * from "./DropHistoryOrders.vue?vue&type=script&lang=js"

import "./DropHistoryOrders.vue?vue&type=style&index=0&id=98b9ec8a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98b9ec8a"]])

export default __exports__